import classnames from 'classnames';

export const PageContainer = ({ header, children }) => (
	<div className={classnames('px-2', 'pb-4')}>
		{header}
		<div className={classnames('px-4', 'mb-4')}>{children}</div>
	</div>
);
